import React, { useMemo } from 'react';
import { Fieldset } from 'src/components/Forms/Fieldset';
import { TextArea } from 'src/components/Forms/TextArea';
import { Fields } from 'src/components/CustomisationPage/feature/customisation.types';
import { Input } from 'src/components/Forms/Input';
import { basicMaxLengthValidation } from 'src/util/forms';
import { BackgroundStyles } from 'src/components/BundleProduct/MultipleStepCustomisation/customisations.types';
import classnames from 'classnames';
import { NOTES_MAX_LENGTH } from 'src/constants/customisation';

import classes from './CommonFooter.scss';

type Props = {
    fieldPrefix?: string;
    isBundleView?: boolean;
    backgroundStyles?: BackgroundStyles;
};

export const CommonFooter: React.FC<Props> = ({ fieldPrefix = '', isBundleView, backgroundStyles }) => {
    const field = (fieldname: string) => `${fieldPrefix}${fieldname}`;
    const validate = useMemo(() => basicMaxLengthValidation(NOTES_MAX_LENGTH), []);
    return (
        <Fieldset disabled={false}>
            <div className={classnames({ [classes.wrapper]: !isBundleView })} style={backgroundStyles}>
                <TextArea
                    label={isBundleView ? 'Special instructions' : 'Notes'}
                    field={field(Fields.specialInstructions)}
                    id={Fields.specialInstructions}
                    placeholder="Please let us know if you have any special requirements"
                    validateOnChange={true}
                    validate={validate}
                />
            </div>
            {isBundleView && (
                <Input
                    label="Customisation name"
                    field={field(Fields.customisationName)}
                    id={Fields.customisationName}
                />
            )}
        </Fieldset>
    );
};
